import {HandleSubscriptionChangeFn} from './types';
import {action} from 'mobx';

export const handleSubscriptionChange: HandleSubscriptionChangeFn = (rootStore) =>
  action(({data: {selectionId}}) => {
    rootStore.$state.subscriptionInput = selectionId;
  });
